import { ArrayList3it5z8td81qkl as ArrayList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { trim11nh7r46at6sx as trim } from '../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  joinTo3lkanfaxbzac2 as joinTo,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Regexxgw0gjiagf4z as Regex } from '../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
import { toSet1glep2u1u9tcb as toSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function addClass(_this__u8e3s4, cssClasses) {
  // Inline function 'kotlin.collections.filterNot' call
  // Inline function 'kotlin.collections.filterNotTo' call
  var destination = ArrayList().w();
  var inductionVariable = 0;
  var last = cssClasses.length;
  while (inductionVariable < last) {
    var element = cssClasses[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    if (!hasClass(_this__u8e3s4, element)) {
      destination.v(element);
    }
  }
  var missingClasses = destination;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!missingClasses.i1()) {
    // Inline function 'kotlin.text.trim' call
    var this_0 = _this__u8e3s4.className;
    var presentClasses = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_1 = StringBuilder().d1();
    this_1.wb(presentClasses);
    // Inline function 'kotlin.text.isEmpty' call
    if (!(charSequenceLength(presentClasses) === 0)) {
      this_1.wb(' ');
    }
    joinTo(missingClasses, this_1, ' ');
    _this__u8e3s4.className = this_1.toString();
    return true;
  }
  return false;
}
function hasClass(_this__u8e3s4, cssClass) {
  var tmp0 = _this__u8e3s4.className;
  // Inline function 'kotlin.text.toRegex' call
  var this_0 = '(^|.*\\s+)' + cssClass + '($|\\s+.*)';
  // Inline function 'kotlin.text.matches' call
  return Regex().qh(this_0).rh(tmp0);
}
function removeClass(_this__u8e3s4, cssClasses) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var inductionVariable = 0;
    var last = cssClasses.length;
    while (inductionVariable < last) {
      var element = cssClasses[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (hasClass(_this__u8e3s4, element)) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  if (tmp$ret$1) {
    var toBeRemoved = toSet(cssClasses);
    // Inline function 'kotlin.text.trim' call
    var this_0 = _this__u8e3s4.className;
    var tmp0 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    // Inline function 'kotlin.text.toRegex' call
    // Inline function 'kotlin.text.split' call
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = Regex().qh('\\s+').zh(tmp0, 0);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element_0 = _iterator__ex2g4s.o1();
      if (!toBeRemoved.t1(element_0)) {
        destination.v(element_0);
      }
    }
    _this__u8e3s4.className = joinToString(destination, ' ');
    return true;
  }
  return false;
}
//region block: exports
export {
  addClass as addClass1ihnmxbr5xjr2,
  hasClass as hasClass3787e36stqarb,
  removeClass as removeClass3jnpygopqxh7s,
};
//endregion

//# sourceMappingURL=Classes.mjs.map
